var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:['cursor', {'animation-isExpanded': _vm.isExpanded}, {'animation-isNotExpanded': !_vm.isExpanded}],attrs:{"size":"14","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }